/** Pull the backend's `{ error }` message off a failed axios request, falling
 *  back to the error's own message, then a generic one. Centralizes the
 *  `err?.response?.data?.error` access so call sites don't each re-spell the
 *  axios error shape. */
export function apiErrorMessage(err: any, fallback: string): string {
  return err?.response?.data?.error || err?.message || fallback;
}
